<script lang="ts">
	import updraft from '$lib/assets/hawk-sil.png';
	import '$lib/styles/baseStyles';
	import { installGlobalErrorReporting } from '$lib/state/errorReporting';
	let { children } = $props();

	// A genuine side effect — installing and removing listeners on `window` —
	// which is one of the few things $effect is actually for. Here rather than
	// in each layout so it covers every route, signed in or not.
	$effect(() => installGlobalErrorReporting());
</script>

<svelte:head>
	<!-- Fallback only; nested layouts replace it with the page's own name. Every
	     page previously rendered an empty <title>, so six tabs of board prep all
	     read "localhost:5173" — poor for an app whose sharing story is "copy the
	     URL". -->
	<title>Updraft</title>
	<link rel="icon" href={updraft} />
</svelte:head>

{@render children?.()}

<style>
</style>
